module.exports = __webpack_public_path__ + "static/img/improvement-items.88754d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/career_panorama/improvement-items.png
// module id = quJi
// module chunks = 1